import ChangePasswordForm from "./ChangePassword";
import './changePassword.scss';

export default ChangePasswordForm;